import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Images, User } from 'lucide-react';
import { MyAlbumEntry } from '../../types';
import { clayStaggerItem } from '../../constants/animations';
import styles from './AlbumCard.module.css';

interface AlbumCardProps {
  album: MyAlbumEntry;
}

export function AlbumCard({ album }: AlbumCardProps) {
  const joinedDate = new Date(album.joinedAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <motion.div variants={clayStaggerItem} style={{ height: '100%' }} data-testid="album-card">
      <Link to={`/albums/${album._id}`} className={styles['card-link']}>
        <motion.div
          className={styles.card}
          whileHover={{ y: -4 }}
          whileTap={{ scale: 0.98 }}
          transition={{ type: 'spring', stiffness: 400, damping: 25 }}
        >
          {/* Thumbnail */}
          {album.firstThumbnail ? (
            <div className={styles.thumbnail}>
              <img
                src={album.firstThumbnail}
                alt={album.name}
                className={styles['thumbnail-img']}
                loading="lazy"
              />
            </div>
          ) : (
            <div className={styles['thumbnail-placeholder']}>
              <Images className={styles['thumbnail-icon']} />
            </div>
          )}

          <div className={styles.body}>
            <div className={styles.header}>
              <h3 className={styles.name}>{album.name}</h3>
            </div>

            <div className={styles.meta}>
              <span className={styles['meta-item']}>
                <User className={styles['icon-xs']} />
                {album.creatorName}
              </span>
              <span className={styles['meta-dot']}>·</span>
              <span className={styles['meta-item']}>{album.eventName}</span>
            </div>

            <div className={styles.footer}>
              <span className={styles['joined-date']}>Joined {joinedDate}</span>
            </div>
          </div>
        </motion.div>
      </Link>
    </motion.div>
  );
}
